'use strict';
import Vue from 'vue';
import Vuex from 'vuex';
//import EventClass from 'event-class-es6';

let defaultState = { globalStatus: {}, spaces: {}, locations: {} };
Vue.use(Vuex);
export default new Vuex.Store({
    state: { ...defaultState },
    mutations: {
        clear(state) {
            Object.keys(state).forEach((key) => (state[key] = defaultState[key]));
        },
        update(state, payload) {
            state.globalStatus = {
                ...state.globalStatus,
                ...payload,
            };
        },
        addSpace(state, payload) {
            state.spaces = {
                ...state.spaces,
                ...payload,
            };
        },
        clearSpaces(state) {
            state.spaces = {};
        },
        addLocation(state, payload) {
            state.locations = {
                ...state.locations,
                ...payload,
            };
        },
        clearLocations(state) {
            state.locations = {};
        },
    },
});
